const $continents = $('#locations_continents');
const $countries = $('#locations_countries');
const $cities = $('#locations_cities');
let requestUrl = '/api/locations/';

function getConfig(type, id) {
  const L = $('body').data('language-uid');
  return $.ajax({
    method: 'GET',
    url: requestUrl,
    data: { type, id, L },
    dataType: 'json',
  });
}

function getContent($el, list) {
  let content = `<option value="0">${$el.attr('data-choose')}</option>`;
  list.forEach((obj) => {
    const selected = obj.selected ? 'selected="selected"' : '';
    content += `<option value="${obj.pageId}" data-url="${obj.url || ''}" ${selected}>${obj.title}</option>`;
  });
  return content;
}

function setDefault($el, list) {
  if (Array.isArray(list) && list.length > 0) {
    $el.removeAttr('disabled').html(getContent($el, list));
  } else {
    $el.prop('disabled', true).html(getContent($el, []));
  }
}

$cities.on('change', (e) => {
  const url = $(e.currentTarget).find(':selected').attr('data-url');
  if (url) {
    window.location.href = url;
  }
});

$countries.on('change', (e) => {
  const id = e.currentTarget.value;
  // get cities
  getConfig(27091985, id)
    .done((cities) => {
      if (Array.isArray(cities)) {
        $cities.removeAttr('disabled').html(getContent($cities, cities));
      }
    })
    .fail();
});

$continents.on('change', (e) => {
  const id = e.currentTarget.value;
  // get countries
  getConfig(27091985, id)
    .done((countries) => {
      if (Array.isArray(countries)) {
        $cities.prop('disabled', true);
        $countries
          .removeAttr('disabled')
          .html(getContent($countries, countries))
          .trigger('change');
      }
    })
    .fail();
});

export default function initLocations(url, pageId) {
  requestUrl = url + requestUrl;
  if (pageId) {
    // get page settings
    getConfig(25091985, pageId)
      .done((data) => {
        const { cities, continents, countries } = data;
        setDefault($cities, cities);
        setDefault($continents, continents);
        setDefault($countries, countries);
      })
      .fail();
  } else {
    // fall back to continents if no pageId provided
    getConfig(27091985, 131)
      .done((continents) => {
        if (Array.isArray(continents)) {
          $continents
            .removeAttr('disabled')
            .html(getContent($continents, continents))
            .trigger('change');
        }
      })
      .fail();
  }
}
